import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Slides } from 'ionic-angular';
import { ImageModel } from '../../models/image.model';

@Component({
  selector: 'page-gallery',
  templateUrl: 'gallery.html',
})
export class GalleryPage {

    @ViewChild('slider') slider: Slides;

    public title: string = '';
    public images: Array<ImageModel> = [];

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams) {        

        this.title = navParams.data.title;

        for (let img in navParams.data.images)
            this.images.push(navParams.data.images[img]);  
  }

  ionViewDidLoad() {

      // Note(Moris): viene introdotto un delay poich� il componente non riesce a posizionarsi sulla slide indicata se non ancora inizializzato.
      // ToDo: invece di utilizzare un delay in msec. che potrebbe variare da dispositivo a dispositivo, utilizzare un evento!!
    
      setTimeout(() => {
          this.slider.slideTo(this.navParams.data.index, 150);
      }, 50);
  }

}



// WEBPACK FOOTER //
// ./src/pages/gallery/gallery.ts